var $ = jQuery;
jQuery(document).ready(function ($)
{
    var helpers = [];

    helpers['menu'] = new MenuController();
    helpers['selector'] = new SelectorController();
    helpers['map'] = new MapController();

});
